module.exports = __webpack_public_path__ + "img/rtc.f1cf4dc5.svg";